export default __webpack_public_path__ + "static/media/html.33745ead.png";